/**
 * Life Balance (Wheel of Life) store — persisted to localStorage.
 * 8 life dimensions, each scored 1–10.
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type SegmentId =
  | 'din'
  | 'karyera'
  | 'pul'
  | 'osish'
  | 'soglik'
  | 'dustlar'
  | 'oila'
  | 'xobbi'

export interface WheelSegment {
  id: SegmentId
  score: number
}

const DEFAULT_SEGMENTS: WheelSegment[] = [
  { id: 'din', score: 5 },
  { id: 'karyera', score: 5 },
  { id: 'pul', score: 5 },
  { id: 'osish', score: 5 },
  { id: 'soglik', score: 5 },
  { id: 'dustlar', score: 5 },
  { id: 'oila', score: 5 },
  { id: 'xobbi', score: 5 },
]

interface LifeBalanceState {
  segments: WheelSegment[]
  editingSegmentId: SegmentId | null
  lastUpdated: string | null
  setScore: (id: SegmentId, score: number) => void
  setEditing: (id: SegmentId | null) => void
  resetScores: () => void
}

export const useLifeBalanceStore = create<LifeBalanceState>()(
  persist(
    (set) => ({
      segments: DEFAULT_SEGMENTS,
      editingSegmentId: null,
      lastUpdated: null,

      setScore: (id, score) =>
        set((state) => ({
          segments: state.segments.map((s) =>
            s.id === id ? { ...s, score: Math.min(10, Math.max(1, score)) } : s,
          ),
          lastUpdated: new Date().toISOString(),
        })),

      setEditing: (id) => set({ editingSegmentId: id }),

      resetScores: () =>
        set({
          segments: DEFAULT_SEGMENTS,
          lastUpdated: null,
        }),
    }),
    {
      name: 'life-balance',
      partialize: (state) => ({
        segments: state.segments,
        lastUpdated: state.lastUpdated,
      }),
    },
  ),
)
